import React, { useState, useEffect, useRef, useMemo } from 'react';
import './slider.css';

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMusicOn, setIsMusicOn] = useState(false);
  const audioRef = useRef(null);

  const slides = useMemo(() => [
    { img: "/assets/Images/8l.webp" },
    { img: "/assets/Images/12l.webp" },
    { img: "/assets/Images/2l.webp" },
    { img: "/assets/Images/4l.webp" },
  ], []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  useEffect(() => {
    const nextIndex = (currentIndex + 1) % slides.length;
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;

    const preloadImage = (index) => {
      const img = new Image();
      img.src = slides[index].img;
    };

    preloadImage(nextIndex);
    preloadImage(prevIndex);
  }, [currentIndex, slides]);

  const toggleMusic = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isMusicOn) {
        audio.pause();
      } else {
        audio.play().catch((err) => console.warn("Error playing audio:", err));
      }
      setIsMusicOn((prev) => !prev);
    }
  };

  const currentSlide = useMemo(() => slides[currentIndex], [currentIndex, slides]);

  return (
    <div className="slider overflow-hidden " role="region" aria-label="Image Slider">
      {/* Audio Player */}
      <audio ref={audioRef} loop preload="auto" aria-hidden="true">
        <source src="/assets/Images/song.mp3" type="audio/mp3" />
      </audio>

      {/* Image Slider */}
      <div className="list">
        <figure key={currentIndex} className="item active">
          <img
            src={currentSlide.img}
            srcSet={`${currentSlide.img}?w=300 300w, ${currentSlide.img}?w=768 768w, ${currentSlide.img}?w=1200 1200w`}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="eager"
            alt="Kitchen Design Slide"
          />
          <figcaption className="content">
            <h2 className="title">Elegant+Quality = Budget-Friendly Premium Kitchen</h2>
            <p className="description">
              "Your Kitchen Design and Modeling Simplified! Laminance offers hundreds of
              colors in premium European-style cabinets, full customization, and premium
              hardware in the most economic way."
            </p>
          </figcaption>
        </figure>
      </div>

      {/* Music Toggle */}
      <div
        className="absolute top-5 left-5 cursor-pointer z-10"
        onClick={toggleMusic}
        aria-label="Toggle Music"
      >
        {/* SVG icon stays the same */}
      </div>

      {/* Thumbnails */}
      <div className="thumbnail">
        {slides.map((slide, index) => (
          <button
            key={index}
            className={`item ${index === currentIndex ? 'active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
            onClick={() => setCurrentIndex(index)}
          >
            <img src={slide.img} alt={`Thumbnail ${index + 1}`} loading="lazy" />
          </button>
        ))}
      </div>

      {/* Navigation Arrows */}
      <div className="nextPrevArrows">
  <button className="prev" onClick={handlePrev} aria-label="Previous Slide">
    <svg xmlns="http://www.w3.org/2000/svg" fill="black" viewBox="0 0 24 24" className="w-5 h-5">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </button>
  <button className="next" onClick={handleNext} aria-label="Next Slide">
    <svg xmlns="http://www.w3.org/2000/svg" fill="black" viewBox="0 0 24 24" className="w-5 h-5">
      <path d="M9 6l6 6-6 6" />
    </svg>
  </button>
</div>
    </div>
  );
};

export default ImageSlider;
